/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../apimodel.d.ts" />
/// <reference path="ivalidatorattributes.d.ts" />
/// <reference path="groupvalidateargs.ts" />

declare module App.Common.Directives {

	interface IGroupValidator {

		name: string;

		nameCamelCase(): string;

		isValid(args: GroupValidateArgs): boolean;

		resolveMessage(args: GroupValidateArgs): string;

		resolveMessageForElement(el: angular.IAugmentedJQuery, errorType: string): string;
	}

}